import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import logo from "../../assets/images/logo_sm.svg";
import { IAppState } from "../../redux/types";
const ServerDeadView = (): JSX.Element => {
  const { t } = useTranslation("common");
  // const rootDispatcher = Dispatcher();
  const isErrorOrganization = useSelector(
    (state: IAppState) => state.healthCheck.organizationServiceError
  );
  const isErrorResidents = useSelector(
    (state: IAppState) => state.healthCheck.residentServiceError
  );
  // useEffect(() => {
  //     const timeout = setInterval(() => {
  //         rootDispatcher.getUsersProfile(false);
  //     }, 3000);
  //     if (isError === false) clearInterval(timeout);
  //     return () => {
  //         clearInterval(timeout);
  //     };
  // }, [rootDispatcher, isError]);

  return isErrorOrganization || isErrorResidents ? (
    <div className="preloader-page">
      <div className={`center suspend ${true ? "" : "desktop"}`}>
        <img src={logo} width={167} height={112} alt="logo" />
        <div className="suspend-text">
          <h2>{t("state.badHeader")}</h2>

          <h5
            dangerouslySetInnerHTML={{ __html: t("state.residentServiceDead") }}
          />
        </div>
      </div>
    </div>
  ) : (
    <Redirect to="/" />
  );
};

export default React.memo(ServerDeadView);
